import React from 'react';
import { Title } from 'components/Misc/Typography';
import Course from 'containers/Student/Courses/Read/Course';

const Month = ({ month }) => {
	return (
		<div className="space-y-2">
			<Title
				title={month.title}
				className="capitalize"
			/>

			<div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
				{month.courses.map(course =>
					<Course key={course.id} course={course} />
				)}
			</div>
		</div>
	);
};

export default Month;